module.exports = __webpack_public_path__ + "assets/img/track-top-bg.35186fd6.png";